import api from '@/utils/api'

// Permission (read-only registry)
export function getPermissionCodeList(params, options) {
  return api.post('/permission/codeList', params, options)
}

// Group
export function getGroupList(params, options) {
  return api.post('/group/list', params, options)
}

export function getGroupRoles(params, options) {
  return api.post('/group/roles', params, options)
}

export function addGroup(params, options) {
  return api.post('/group/add', params, options)
}

export function modifyGroup(params, options) {
  return api.post('/group/modify', params, options)
}

export function deleteGroup(id, options) {
  return api.delete(`/group/${id}`, null, options)
}

// Role
export function getRoleList(params, options) {
  return api.post('/role/list', params, options)
}

export function getRolePermissionList(params, options) {
  return api.post('/role/permissionList', params, options)
}

export function modifyRolePermission(params, options) {
  return api.post('/role/modifyPermission', params, options)
}

export function addRole(params, options) {
  return api.post('/role/add', params, options)
}

export function modifyRole(params, options) {
  return api.post('/role/modify', params, options)
}

export function deleteRole(id, options) {
  return api.delete(`/role/${id}`, null, options)
}

// Account
export function getAccountList(params, options) {
  return api.post('/account/list', params, options)
}

export function addAccount(params, options) {
  return api.post('/account/add', params, options)
}

export function modifyAccount(params, options) {
  return api.post('/account/modify', params, options)
}

export function deleteAccount(address, options) {
  return api.delete(`/account/${address}`, null, options)
}

export function getAccountGroups(params, options) {
  return api.post('/account/groups', params, options)
}

export function assignGroup(params, options) {
  return api.post('/account/assignGroup', params, options)
}

export function removeGroup(params, options) {
  return api.post('/account/removeGroup', params, options)
}

export function getAccountSettings(options) {
  return api.get('/account/settings', null, options)
}

export function saveAccountSettings(params, options) {
  return api.post('/account/settings', params, options)
}

// Menu
export function getMenuList(params, options) {
  return api.get('/menu/list', params, options)
}

// Network
export function getNetworkList(params, options) {
  return api.post('/network/list', params, options)
}

export function addNetwork(params, options) {
  return api.post('/network/add', params, options)
}

export function modifyNetwork(params, options) {
  return api.post('/network/modify', params, options)
}

export function deleteNetwork(id, options) {
  return api.delete(`/network/${id}`, null, options)
}

// API Key
export function getApiKeyList(params, options) {
  return api.post('/apikey/list', params, options)
}

export function addApiKey(params, options) {
  return api.post('/apikey/add', params, options)
}

export function modifyApiKey(params, options) {
  return api.post('/apikey/modify', params, options)
}

export function deleteApiKey(issuer, options) {
  return api.delete(`/apikey/${issuer}`, null, options)
}

// API Key Expiry
export function getApiKeyExpiryList(params, options) {
  return api.post('/apikey/expiry/list', params, options)
}

export function setApiKeyExpiry(params, options) {
  return api.post('/apikey/expiry/set', params, options)
}

export function renewApiKey(params, options) {
  return api.post('/apikey/expiry/renew', params, options)
}

export function getExpiringApiKeys(params, options) {
  return api.post('/apikey/expiry/expiring', params, options)
}

export function checkExpiringApiKeys(options) {
  return api.post('/apikey/expiry/check', {}, options)
}

// Contract
export function getContractList(params, options) {
  return api.post('/contract/list', params, options)
}

export function modifyContract(params, options) {
  return api.post('/contract/modify', params, options)
}

// Admin Activity Log
export function getAdminActivityLogList(params, options) {
  return api.post('/admin_activity_log/list', params, options)
}

export function getActivityLogDetail(id, options) {
  return api.post('/admin_activity_log/detail', { id }, options)
}

// Threshold Settings
export function getThresholdSettings(options) {
  return api.post('/threshold_settings/get', {}, options)
}

export function saveThresholdSettings(params, options) {
  return api.post('/threshold_settings/save', params, options)
}

// Login History
export function getLoginHistoryList(params, options) {
  return api.post('/login_history/list', params, options)
}

// Session Management
export function listSessions(options) {
  return api.post('/session_management/list', {}, options)
}

export function revokeSession(sessionId, options) {
  return api.post(
    '/session_management/revoke',
    { session_id: sessionId },
    options
  )
}

export function revokeAllOtherSessions(options) {
  return api.post('/session_management/revoke_all_others', {}, options)
}

export function getSessionConfig(options) {
  return api.post('/session_management/get_config', {}, options)
}

export function setSessionConfig(ttlHours, options) {
  return api.post(
    '/session_management/set_config',
    { session_ttl_hours: ttlHours },
    options
  )
}

// IP Whitelist
export function getIPWhitelistList(options) {
  return api.post('/ip_whitelist/list', {}, options)
}

export function addIPWhitelist(params, options) {
  return api.post('/ip_whitelist/add', params, options)
}

export function updateIPWhitelist(params, options) {
  return api.post('/ip_whitelist/update', params, options)
}

export function deleteIPWhitelist(params, options) {
  return api.post('/ip_whitelist/delete', params, options)
}

export function getIPWhitelistStatus(options) {
  return api.post('/ip_whitelist/get_status', {}, options)
}

export function setIPWhitelistEnabled(params, options) {
  return api.post('/ip_whitelist/set_enabled', params, options)
}

// Health Check
export function getHealthCheck(options) {
  return api.post('/health_check/check', {}, options)
}

// API Statistics
export function getApiStats(params, options) {
  return api.post('/admin_activity_log/stats', params, options)
}

// Withdraw Statistics Dashboard
export function getWithdrawStatsSummary(params, options) {
  return api.post('/withdraw_stats/summary', params, options)
}

export function getWithdrawStatsTrends(params, options) {
  return api.post('/withdraw_stats/trends', params, options)
}

// Anomaly Detection
export function getAnomalyRules(options) {
  return api.post('/anomaly_detection/get_rules', {}, options)
}

export function updateAnomalyRule(params, options) {
  return api.post('/anomaly_detection/update_rule', params, options)
}

export function getAnomalyAlerts(params, options) {
  return api.post('/anomaly_detection/get_alerts', params, options)
}

export function acknowledgeAnomalyAlert(params, options) {
  return api.post('/anomaly_detection/acknowledge_alert', params, options)
}

export function getAnomalySummary(options) {
  return api.post('/anomaly_detection/get_summary', {}, options)
}

// Price Alerts
export function getPriceAlertList(options) {
  return api.post('/price_alert/list', {}, options)
}

export function createPriceAlert(params, options) {
  return api.post('/price_alert/create', params, options)
}

export function updatePriceAlert(params, options) {
  return api.post('/price_alert/update', params, options)
}

export function deletePriceAlert(params, options) {
  return api.post('/price_alert/delete', params, options)
}

export function togglePriceAlertEnabled(params, options) {
  return api.post('/price_alert/toggle_enabled', params, options)
}

export function getPriceAlertHistory(params, options) {
  return api.post('/price_alert/history', params, options)
}

// Backup Monitor
export function getBackupStatus(params, options) {
  return api.post('/backup_monitor/status', params || {}, options)
}

export function getBackupHistory(params, options) {
  return api.post('/backup_monitor/history', params, options)
}

export function triggerBackup(params, options) {
  return api.post('/backup_monitor/trigger', params, options)
}

export function getBackupConfig(params, options) {
  return api.post('/backup_monitor/get_config', params || {}, options)
}

export function updateBackupConfig(params, options) {
  return api.post('/backup_monitor/update_config', params, options)
}
